export class CTWorkOrderCustomTemplate{

  Content?: string;
  Oid? : number;
  WorkOrder: { Oid: number } | any | null = null;
  UserInfo?: { Oid: number } | any | null = null;

  public static create = (): CTWorkOrderCustomTemplate => new CTWorkOrderCustomTemplate();

  constructor(){}

  setOid(value : number){

    this.Oid = value;
    return this;

  }

  setContent(value : string){

    this.Content = value;
    return this;

  }

  setWorkOrder(value : number){

    this.WorkOrder = {Oid : value};
    return this;

  }


}
